/**
 * Product Page Discount Badge Handler
 * Updates discount badge when variant changes on PDP
 */

class ProductPageBadgeHandler {
  constructor() {
    this.init();
  }

  init() {
    // Listen for variant change events from Shopify
    document.addEventListener('variant:change', (event) => {
      if (event.detail && event.detail.variant) {
        this.updateBadge(event.detail.variant);
      }
    });

    // Listen for BSUB variant changes
    document.addEventListener('bsub:variant:changed', (event) => {
      if (event.detail && event.detail.variant) {
        this.updateBadge(event.detail.variant);
      }
    });

    // Also listen for older variant change methods
    const variantSelects = document.querySelectorAll('variant-radios, variant-selects');
    variantSelects.forEach(select => {
      select.addEventListener('change', () => {
        // Get current variant from the select
        const variantId = select.querySelector('input:checked, select')?.value;
        if (variantId) {
          this.updateBadgeById(variantId);
        }
      });
    });

    // Listen for product-form updates
    const productForms = document.querySelectorAll('product-form');
    productForms.forEach(form => {
      const observer = new MutationObserver(() => {
        this.checkAndUpdateBadge();
      });
      
      observer.observe(form, {
        attributes: true,
        attributeFilter: ['data-variant-id'],
        childList: false,
        subtree: false
      });
    });
  }

  updateBadgeById(variantId) {
    // Get variant data from product JSON
    const productJson = document.querySelector('[type="application/json"][data-product-json]');
    if (!productJson) return;

    try {
      const product = JSON.parse(productJson.textContent);
      const variant = product.variants.find(v => v.id == variantId);
      
      if (variant) {
        this.updateBadge(variant);
      }
    } catch (e) {
      console.error('Error parsing product JSON:', e);
    }
  }

  checkAndUpdateBadge() {
    // Get current variant from URL or form
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get('variant');
    
    if (variantId) {
      this.updateBadgeById(variantId);
    }
  }

  updateBadge(variant) {
    // Find the discount badge on the first media item
    const firstMediaItem = document.querySelector('.product__media-item:first-child, .slider__slide:first-child');
    if (!firstMediaItem) return;

    let badge = firstMediaItem.querySelector('.discount-badge');
    
    const compareAtPrice = variant.compare_at_price;
    const price = variant.price;
    
    if (compareAtPrice && compareAtPrice > price) {
      // Calculate discount percentage
      const discount = Math.round(((compareAtPrice - price) / compareAtPrice) * 100);
      
      if (badge) {
        // Update existing badge
        badge.textContent = `-${discount}%`;
        badge.setAttribute('data-discount', discount);
        badge.style.display = 'flex';
      } else {
        // Create new badge
        this.createBadge(firstMediaItem, discount);
      }
    } else {
      // Hide badge if no discount
      if (badge) {
        badge.style.display = 'none';
        badge.setAttribute('data-discount', '0');
      }
    }
  }

  createBadge(container, discount) {
    // Get badge style from settings
    const badgeStyle = this.getBadgeStyle();
    
    const badge = document.createElement('div');
    badge.className = `discount-badge discount-badge--${badgeStyle}`;
    badge.textContent = `-${discount}%`;
    badge.setAttribute('data-discount', discount);
    
    container.appendChild(badge);
  }

  getBadgeStyle() {
    // Try to get from body data attribute or settings
    if (document.body.dataset.discountBadgeStyle) {
      return document.body.dataset.discountBadgeStyle;
    }
    
    // Check if a badge already exists and use its style
    const existingBadge = document.querySelector('.discount-badge');
    if (existingBadge) {
      if (existingBadge.classList.contains('discount-badge--rectangle')) {
        return 'rectangle';
      }
      return 'circle';
    }
    
    // Default to circle
    return 'circle';
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ProductPageBadgeHandler();
  });
} else {
  new ProductPageBadgeHandler();
}
